import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Radio } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import ProdutoFrame from './ProdutoFrame';

const { Item: ItemForm } = Form;

export default class EstoqueForm extends Component {
  state = {
    consulta: false,
    registro: {
      est_idf: 0,
      est_produto: { key: '0' },
      prod_codigo: '',
      prod_descricao: '',
      est_qtde_atual: 0,
      est_qtde_contada: 0,
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      // console.log('componentDidUpdate: ', this.props.registroSelecionado)
      this.setState({
        registro: this.props.registroSelecionado.dados,
        consulta: this.props.registroSelecionado.consulta,
      }, () => {

      });
    }
  }

  componentDidMount() {

  }


  onOK = () => {
    const { est_idf, est_produto, est_qtde_atual, est_qtde_contada } = this.state.registro;

    let iIndProd = -1;
    if ((!est_produto) || (est_produto.key === '0') || (est_produto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Produto', });
      return;
    }

    const registro = {
      est_idf: est_idf,
      est_produto: est_produto.key,
      est_qtde_atual: parseFloat(est_qtde_atual),
      est_qtde_contada: parseFloat(est_qtde_contada),
    };

    this.props.onSalvarClick(registro);
  };



  onChangeProduto = event => {
    // console.log('onChangeProduto', event.est_produto)
    const { registro } = this.state;
    registro['est_produto'] = event.est_produto;
    registro['est_qtde_atual'] = event.est_produto.prod_qtde_atual;
    this.setState(event);
  }



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };





  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onCancelarClick, visivel } = this.props;
    const { consulta } = this.state;
    const { est_idf, est_produto, est_qtde_atual, est_qtde_contada } = this.state.registro;

    // console.log('EstoqueForm.this.state: ', this.state);

    return (
      <Modal
        title={est_idf ? "Editar Contagem" : "Incluir Contagem"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 50 }}
      >
        <div>

          <Row>

            <Col xs={24}>
              <ProdutoFrame
                label="Produto"
                id="est_produto"
                value={est_produto}
                verifica_prod_vend={true}
                width={"100%"}
                onChange={this.onChangeProduto}
                descricaoPrimeiroItem="Selecione um Produto"
                disabled={est_idf}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Qtde Atual</span>
              <InputForm
                type="number"
                id="est_qtde_atual"
                ref="est_qtde_atual"
                value={est_qtde_atual}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Qtde Contada</span>
              <InputForm
                type="number"
                id="est_qtde_contada"
                ref="est_qtde_contada"
                value={est_qtde_contada}
                onChange={this.onChange}
              />
            </Col>
          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                {consulta ? null : (
                  <Button
                    htmlType="button"
                    onClick={this.onOK}
                    className="botoesModalForm2x"
                  >
                    Salvar
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EstoqueForm.js